document.addEventListener('DOMContentLoaded', function () {
  /* ===============================
     DELIVERY TYPE TOGGLE
  =============================== */
  const pickupCheckbox = document.getElementById('pickupOption');
  const deliveryCheckbox = document.getElementById('deliveryOption');
  const pickupFields = document.getElementById('pickupFields');
  const deliveryFields = document.getElementById('deliveryFields');
  

  function toggleDeliveryType() {
    if (pickupCheckbox.checked && deliveryCheckbox.checked) {
      if (this.id === 'pickupOption') {
        deliveryCheckbox.checked = false;
      } else {
        pickupCheckbox.checked = false;
      }
    }

    if (!pickupCheckbox.checked && !deliveryCheckbox.checked) {
      pickupCheckbox.checked = true;
    }

    if (pickupCheckbox.checked) {
      pickupFields.classList.remove('hidden');
      deliveryFields.classList.add('hidden');
      pickupFields.querySelectorAll('input, select').forEach(el => el.required = true);
      deliveryFields.querySelectorAll('input').forEach(el => el.required = false);
    } else {
      pickupFields.classList.add('hidden');
      deliveryFields.classList.remove('hidden');
      deliveryFields.querySelectorAll('input').forEach(el => el.required = true);
      pickupFields.querySelectorAll('input, select').forEach(el => el.required = false);
    }
  }

  pickupCheckbox?.addEventListener('change', toggleDeliveryType);
  deliveryCheckbox?.addEventListener('change', toggleDeliveryType);

  /* ===============================
     CHARACTER COUNT
  =============================== */
  const instructionsTextarea = document.getElementById('orderInstructions');
  const charCountSpan = document.getElementById('charCount');

  if (instructionsTextarea && charCountSpan) {
    instructionsTextarea.addEventListener('input', function () {
      charCountSpan.textContent = this.value.length;
    });
  }

  /* ===============================
     CART COUNT UPDATE
  =============================== */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  // Initial sync
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

  /* ===============================
     AJAX CART UPDATE
  =============================== */
  function updateQuantity(line, quantity) {
    const cartItem = document.querySelector(`.main-cart-item[data-line="${line}"]`);
    if (!cartItem) return;

    cartItem.classList.add('loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    })
      .then(response => response.json())
      .then(data => {
        // 🔹 UPDATE CART COUNT
        updateCartCount(data.item_count);

        if (quantity === 0) {
          cartItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          cartItem.style.opacity = '0';
          cartItem.style.transform = 'translateX(-20px)';

          setTimeout(() => {
            cartItem.remove();
            if (document.querySelectorAll('.main-cart-item').length === 0) {
              location.reload();
            }
          }, 300);
        } else {
          const newItem = data.items[line - 1];
          const priceElement = cartItem.querySelector('.cart-item-price');
          priceElement.textContent = formatMoney(newItem.final_line_price);

          const qtyInput = cartItem.querySelector('.quantity-input');
          qtyInput.value = quantity;

          cartItem.querySelector('.qty-plus')?.setAttribute('data-qty', quantity);
          cartItem.querySelector('.qty-minus')?.setAttribute('data-qty', quantity);
        }

        cartItem.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error:', error);
        cartItem.classList.remove('loading');
        showErrorMessage('Error updating cart. Please try again.');
      });
  }

  function formatMoney(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }

  /* ===============================
     ERROR TOAST
  =============================== */
  function showErrorMessage(message) {
    document.querySelector('.error-toast')?.remove();

    const errorToast = document.createElement('div');
    errorToast.className = 'error-toast';
    errorToast.textContent = message;
    errorToast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #ff4444;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 9999;
      font-size: 14px;
      animation: slideIn 0.3s ease;
    `;

    document.body.appendChild(errorToast);

    setTimeout(() => {
      errorToast.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => errorToast.remove(), 300);
    }, 3000);
  }

  /* ===============================
     QUANTITY BUTTONS
  =============================== */
  document.addEventListener('click', function (e) {
    const plusBtn = e.target.closest('.qty-plus');
    const minusBtn = e.target.closest('.qty-minus');
    const removeBtn = e.target.closest('.remove-btn');

    if (plusBtn) {
      e.preventDefault();
      updateQuantity(+plusBtn.dataset.line, +plusBtn.dataset.qty + 1);
    }

    if (minusBtn) {
      e.preventDefault();
      const qty = +minusBtn.dataset.qty;
      if (qty > 1) {
        updateQuantity(+minusBtn.dataset.line, qty - 1);
      }
    }

    if (removeBtn) {
      e.preventDefault();
      updateQuantity(+removeBtn.dataset.line, 0);
    }
  });

  /* ===============================
     MIN DATE = TODAY
  =============================== */
  const today = new Date().toISOString().split('T')[0];
  document.querySelectorAll('input[type="date"]').forEach(input => {
    input.min = today;
  });

  /* ===============================
     ANIMATIONS CSS
  =============================== */
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
});
